import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const RightPanelContext = createContext();

export const RightPanelProvider = ({ children, mode = 'sidebar' }) => {
  const [activePanel, setActivePanel] = useState('hot'); // 'hot', 'publish', 'notification'
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const togglePanel = useCallback((panel) => {
    if (mode === 'drawer') {
      setActivePanel((current) => {
        setIsPanelOpen((open) => (current === panel ? !open : true));
        return panel;
      });
      return;
    }

    setIsPanelOpen(false);
    setActivePanel((current) => (current === panel ? 'hot' : panel));
  }, [mode]);

  const closePanel = useCallback(() => {
    setIsPanelOpen(false);
    if (mode === 'drawer') {
      setActivePanel('hot');
    }
  }, [mode]);

  useEffect(() => {
    if (mode !== 'drawer') {
      setIsPanelOpen(false);
    }
  }, [mode]);

  const value = useMemo(
    () => ({ activePanel, setActivePanel, isPanelOpen, togglePanel, closePanel, mode }),
    [activePanel, isPanelOpen, togglePanel, closePanel, mode]
  );

  return (
    <RightPanelContext.Provider value={value}>
      {children}
    </RightPanelContext.Provider>
  );
};

export const useRightPanel = () => {
  const context = useContext(RightPanelContext);
  if (!context) {
    throw new Error('useRightPanel must be used within a RightPanelProvider');
  }
  return context;
};
